import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShieldBreak: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"shield-break, not-secure"} maskId="square-filled-radius-0-stroke-1-IconShieldBreak"><path d="M19.1667 18.4448L22.5741 21.2032L23.2033 20.426L1.42607 2.79675L0.796875 3.574L3 5.35748V13C3 17.9705 7.02944 22 12 22C14.9243 22 17.5228 20.6053 19.1667 18.4448Z" fill="currentColor"/><path d="M21 13C21 14.3226 20.7147 15.5786 20.2023 16.7097L4.9496 4.36233L12 1.45923L21 5.16511V13Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconShieldBreak;
